export default {"src":"/_next/static/media/arrow-path.c16df234.svg","height":24,"width":83};